module.exports = __webpack_public_path__ + "img/other-img1.ff1717ec.png";